import * as React from 'react';
export const IcWifiOff = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M5.4 12.81a1 1 0 001.41.11l.12-.1 3.73-3.72a10.06 10.06 0 00-5.15 2.3.999.999 0 00-.11 1.41zM4 10.08A11.94 11.94 0 0112 7h.72l1.81-1.8A14.26 14.26 0 0012 5a14 14 0 00-9.34 3.59A1.002 1.002 0 004 10.08zm17.34-1.49a13.891 13.891 0 00-2.63-1.85L20.49 5a1.055 1.055 0 00-1.148-1.719c-.128.053-.244.13-.342.229L3.51 19A1.052 1.052 0 105 20.49l4.7-4.71a4 4 0 014.73 0 1 1 0 001.2-1.6 5.999 5.999 0 00-3.2-1.16l1.76-1.75a8 8 0 013 1.62 1 1 0 001.3-1.52 9.848 9.848 0 00-2.78-1.67l1.52-1.52c1.008.5 1.94 1.14 2.77 1.9a1 1 0 001.075.163 1 1 0 00.265-1.653zM12 17a1.5 1.5 0 100 2.999 1.5 1.5 0 000-3z'
      fill='currentColor'
    />
  </svg>
);
